<template>
  <base-section
    id="submit-workshops"
  >
    <base-section-heading
      title="Submit a proposal"
    />
    <v-container>
      <base-section-heading
        divider="null"
      >
        <v-btn
          href="https://welcome.molesystems.com/tttc/ETS/2023/"
          target="_blank"
          rounded
          color="green"
          dark
          download
          style="padding: 15px"
        >
          <v-icon
            left
            dark
          >
            mdi-open-in-new
          </v-icon>
          Link to the Sumissions website
        </v-btn>
        <br>
        <br>
        The IEEE European Test Symposium (ETS) 2023 seeks original, unpublished contributions for:<br>
        • <strong>Fringe Workshops proposals</strong> about relevant and timely topics.<br>
        On the submission site, please select <strong>"3-Workshop Proposal"</strong>, and upload a PDF file using the provided <a
        href="Workshop_Submission_Template.docx"
        download
        >template</a> filled with the requested information.
      </base-section-heading>
      <base-section-heading>
        We welcome you all to the 28th European Test Symposium ETS 2023 in Venice. The technical program of ETS 2023 addresses many trends and challenges in semiconductor design and manufacturing process covering a range of topics spanning from Analog, Mixed-Signal, RF, DfT, Test Access Standards, Validation, Verification Debug and Diagnosis, Test generation, Fault Simulation, Fault Tolerance, Application, and evaluation. Moreover, we added hot-topics that are now driving semiconductor business: Dependable AI, AI for Testing, Functional Safety and Reliability in Automotive Emerging technologies, Emerging architectures, Security, and Trust. Looking forward to your submissions.
      </base-section-heading>
       <br>
      <br>
        <v-footer
          id="program-footer"
          color="primary"
          dark
          min-height="72"
          class="hidden-md-and-up"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
                  <template v-for="(s, i) in workshopsfooter">
                    <router-link
                      :key="s.name"
                      class="white--text pa-1 pa-md-0"
                      :to="s.url"
                      v-text="s.name"
                    />

                    <v-responsive
                      v-if="i < workshopsfooter.length - 1"
                      :key="`divider-${s.name}`"
                      class="mx-4 shrink hidden-sm-and-down"
                      max-height="24"
                    >
                      <v-divider vertical />
                    </v-responsive>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SubmitWorkshops',
    data: () => ({
      isMobile: false,
      workshopsfooter: [
        {
          name: 'Fringe Workshops',
          url: 'fringe-workshops',
        },
      ],
      mounted () {
        this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
      methods: {
        isMobileDevice () {
          return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
        },
      },
    }),
  }
</script>
